module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/245-jersey-a5e0e03dcbf81ca852d89a10f9c03171.svg";